import { Text, VStack, Image } from "@chakra-ui/react";
import React from "react";
import { COLORS } from "../../../Helper/Colors";

export const ProfileDetailsItem = ({ label, value, type }) => {
	return (
		<VStack alignItems='start' width={"72"}>
			<Text color={COLORS.dark} fontSize='md' fontWeight={"normal"}>
				{!!label && label}
			</Text>
			{type !== "image" ? (
				<Text color={COLORS.dark} wordBreak='break-word' fontSize='md' fontWeight={"medium"}>
					{!!value && value}
				</Text>
			) : (
				<Image height='64px' width='64px' borderRadius='3px' src={value} />
			)}
		</VStack>
	);
};
